const processSpeech = speech => {
  const command = speech.toLowerCase();
  console.log('Voice command: ' + command);

  // "Hey" isn't always recognised but "Carol" consistently is
  if (command.includes('carol')) {
    // if (command.includes('margarets road'))
    //   document.location.href =
    //     '/admin/hydra/MATG44f6e5c4-1453-4a9f-8773-ff0e0bc12393';
    if (
      command.includes('dashboard') ||
      command.includes('alerts') ||
      command.includes('sessions') ||
      command.includes('stations')
    )
      document.location.href = '/admin';
    if (command.includes('hubs')) document.location.href = '/admin/hubs';
    if (command.includes('customers'))
      document.location.href = '/admin/customers';
    if (command.includes('users')) document.location.href = '/admin/users';
    if (command.includes('map')) document.location.href = '/admin/map';
    if (command.includes('weather')) document.location.href = '/admin/weather';
    if (command.includes('fireworks') || command.includes('thumbs')) {
      document.location.href = '/admin?fireworks=true';
    }
  }
};

export const speechHandler = {
  init: function(onPartialSpeech, onFinalSpeech) {
    this.onPartialSpeech = onPartialSpeech;
    this.onFinalSpeech = onFinalSpeech;

    this.transcript = '';

    this.ignoreOnEnd = false;
    //this.startTimestamp = event.timeStamp;

    if (this.enabled) return;
    this.enabled = true;

    if (!('webkitSpeechRecognition' in window)) {
      // TDTODO - "Web Speech API is not supported by this browser. Upgrade to <a href='//www.google.com/chrome'>Chrome</a> version 25 or later."
      return;
    }

    this.recognition = new window.webkitSpeechRecognition();
    this.recognition.lang = 'en-US';
    // var grammar = '#JSGF V1.0; grammar colors; public <color> = aqua | azure | beige | bisque | black | blue | brown | chocolate | coral | crimson | cyan | fuchsia | ghostwhite | gold | goldenrod | gray | green | indigo | ivory | khaki | lavender | lime | linen | magenta | maroon | moccasin | navy | olive | orange | orchid | peru | pink | plum | purple | red | salmon | sienna | silver | snow | tan | teal | thistle | tomato | turquoise | violet | white | yellow ;'
    // var speechRecognitionList = new SpeechGrammarList();
    // speechRecognitionList.addFromString(grammar, 1);
    // this.recognition.grammars = speechRecognitionList;
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.start();

    this.recognition.onstart = function() {};

    const onError = function(event) {
      if (event.error === 'no-speech') {
        // No speech was detected. You may need to adjust your microphone settings.
        this.ignoreOnEnd = true;
      }

      if (event.error === 'audio-capture') {
        // TDTODO - "No microphone was found. Ensure that a microphone is installed and that <a href="//support.google.com/chrome/bin/answer.py?hl=en&amp;answer=1407892"> microphone settings</a> are configured correctly."
        this.ignoreOnEnd = true;
      }

      if (event.error === 'not-allowed') {
        //if (event.timeStamp - startTimestamp < 100) {
        // TDTODO - "Permission to use microphone is blocked. To change, go to chrome://settings/contentExceptions#media-stream"
        //} else {
        // TDTODO - "Permission to use microphone was denied."
        //}
        this.ignoreOnEnd = true;
      }
    };

    const onEnd = function() {
      if (!this.enabled) return;

      if (this.ignoreOnEnd) return;

      // Restart
      try {
        this.transcript = '';
        this.recognition.start();
      } catch (error) {}
    };

    const onResult = function(event) {
      if (!this.enabled) return;

      if (typeof event.results === 'undefined') {
        this.recognition.onend = null;
        this.recognition.stop();
        // TDTODO - "Web Speech API is not supported by this browser. Upgrade to <a href='//www.google.com/chrome'>Chrome</a> version 25 or later."
        return;
      }

      var interimTranscript = '';
      var finalTranscript = '';

      for (var i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        } else {
          interimTranscript += event.results[i][0].transcript;
        }
      }

      finalTranscript = finalTranscript.trim();
      interimTranscript = interimTranscript.trim();

      if (finalTranscript.length > 0) {
        this.transcript = finalTranscript;
        this.recognition.stop();
        if (this.onFinalSpeech) this.onFinalSpeech(finalTranscript);

        processSpeech(finalTranscript);

        this.transcript = '';
      } else if (interimTranscript.length > 0) {
        this.transcript = interimTranscript;
        if (this.onPartialSpeech) this.onPartialSpeech(this.transcript);
      }
    };

    this.recognition.onend = onEnd.bind(this);
    this.recognition.onerror = onError.bind(this);
    this.recognition.onresult = onResult.bind(this);
  },

  stop: function() {},

  enable: function(enabled) {
    this.enabled = enabled;
  }
};

if (localStorage.getItem('voiceEnabled') === 'true') {
  speechHandler.init(null, null);
  speechHandler.enable(true);
} else {
  speechHandler.enable(false);
}
